<template>
    <div
        v-if="isShowModal"
        class="o-mobile-map-modal"
        @click.self="closeModal"
    >
        <OOtgModalContainer 
            :headerLabel="$t('ui.mobile-map')"
            @onClose="closeModal"
        >
            <component :is="innerBlock" />
        </OOtgModalContainer>
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';

import OOtgModalContainer from "../o-otg-modal-container";
import OMobileMapModalInnerGranby from '../../unique-organisms/o-mobile-map-modal-inner-granby';
import OMobileMapModalInnerMobilia from '../../unique-organisms/o-mobile-map-modal-inner-mobilia';

import { EVENTS } from "../../../utils/constants/bus-events-constants";

export default {
    name: 'OMobileMapModal',
    components: {
        OOtgModalContainer,
        OMobileMapModalInnerGranby,
        OMobileMapModalInnerMobilia
    },
    data() {
        return {
            isShowModal: false
        }
    },
    computed: {
        ...mapState({
            mapId: state => state.map.id
        }),
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonConfigParams() {
            return this.getMapConfigProp('components.OMobileMapModal.params') || {};
        },
        innerBlock() {
            return this.commonConfigParams.innerBlock ?? 'OMobileMapModalInnerMobilia'
        }
    },
    mounted() {
        this.initListeners();
    },
    methods: {
        initModal() {
            this.isShowModal = true;
        },
        closeModal() {
            this.isShowModal = false;
        },
        initListeners() {
            this.$bus.$on(EVENTS.MODALS.OFF_MODAL, this.closeModal);
            this.$bus.$on(EVENTS.MODALS.MOBILE_MAP_INIT, this.initModal);
        },
        removeListeners() {
            this.$bus.$off(EVENTS.MODALS.OFF_MODAL, this.closeModal);
            this.$bus.$off(EVENTS.MODALS.MOBILE_MAP_INIT, this.initModal);
        }
    },
    beforeDestroy() {
        this.removeListeners();
    }
}
</script>

<style lang="scss" src="./theme.scss" />